import { useTranslation } from 'react-i18next';
import { Col, DropdownButton, Glyphicon, MenuItem } from 'react-bootstrap';
import TextField from 'components/forms/textField/TextField';
import useCopyToClipboard from 'hooks/useCopyToClipboard';
import { UnitListSchemaType } from '../PropertySettingsUnitsTab.schema';
import useDeactivateConfirmationModal from '../modals/useDeactivateConfirmationModal';
import useDeleteConfirmationModal from '../modals/useDeleteConfirmationModal';
import {
  UnitRow,
  UnitStatus,
  UnitNameCol,
  UnitUidAndStatusCol,
  UnitStatusCol,
} from './UnitList.styles';

const UnitListItem = ({
  unit,
  index,
}: {
  unit: NonNullable<UnitListSchemaType['units']>[number];
  index: number;
}) => {
  const { t } = useTranslation();
  const { getCopyAddonIcon } = useCopyToClipboard();
  const { openDeactivateConfirmationModal } =
    useDeactivateConfirmationModal(unit);
  const { openDeleteConfirmationModal } = useDeleteConfirmationModal(unit);

  return (
    <UnitRow data-testid={`unit-row-${unit.uid}`}>
      <UnitNameCol xs={12} md={4}>
        <TextField name={`units.${index}.name`} />
      </UnitNameCol>

      <UnitUidAndStatusCol xs={12} md={8}>
        {!unit.isTemporary && (
          <Col xs={8} md={6}>
            <TextField
              name={`units.${index}.uid`}
              defaultValue={unit.uid}
              rightAddons={[getCopyAddonIcon(unit.uid)]}
              disabled
            />
          </Col>
        )}

        <UnitStatusCol xs={4} md={6} mdOffset={unit.isTemporary ? 6 : 0}>
          <UnitStatus $isActive={!!unit.isActive}>
            {unit.isActive
              ? t('pageProperty.units.status.active')
              : t('pageProperty.units.status.inactive')}
          </UnitStatus>
          <DropdownButton
            id={`unit-status-dropdown-${unit.uid}`}
            title={<Glyphicon glyph="cog" />}
            noCaret
            pullRight
          >
            <MenuItem onClick={openDeactivateConfirmationModal}>
              {unit.isActive
                ? t('pageProperty.units.status.deactivate')
                : t('pageProperty.units.status.activate')}
            </MenuItem>
            <MenuItem onClick={openDeleteConfirmationModal}>
              {t('common.delete')}
            </MenuItem>
          </DropdownButton>
        </UnitStatusCol>
      </UnitUidAndStatusCol>
    </UnitRow>
  );
};

export default UnitListItem;
